/**
 * Created by yoavp on 11/20/2014.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Template = require("connection-templates/KPsTab/kpSnippetItemView.tmpl");
    var CP_CONST = require("connection-const");

    var KPSnippetView = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {

        KPSnippetView = Marionette.ItemView.extend({
            template: Template,
            type: null,
            className: 'snippet-container',
            isSelected: false,

            ui: {
                snippetType: ".snippet-type",
                noResultsMessage: ".no-results",
                snippet: ".snippet"
            },

            events: {
                click: "_onClick"
            },

            initialize: function (options) {
                this.options = options || {};
                this.permutation = options.permutation || CP_CONST.SNIPPET_PERMUTATION.PANEL;

                if (options.type) {
                    this.type = options.type;
                }

                this.setPropertiesAndMethodByPermutation(options);
            },

            setSelected: function (slug) {
                if (slug && this.model.get("slug") === slug) {
                    this.select();
                }
                else {
                    this.unSelect();
                }
            },

            unSelect: function () {
                this.ui.snippet.removeClass("is-selected");
            },

            select: function () {
                this.ui.snippet.addClass("is-selected");
            },

            _onClick: function () {
                if(this.model.get('isNew')){
                    this.model.set('isRead', true);
                }
                LEConnection.trigger("kpSnippet:selected", {
                    snippetModel: this.model,
                    type: this.type
                });
                if (this.type == CP_CONST.REFERER_ACTION.CANNED_RESPONSE){
                    var eventObj = {};
                    eventObj.usageToTrack = CP_CONST.USAGE_TO_TRACK.CONTENT.OPEN_CONTENT_IN_CHAT;
                    eventObj.slug = this.model.get("slug");
                    LEConnection.vent.trigger("UsageTrackingController:track", eventObj);
                }
            },

            // constructing the correct snippet per use case
            setPropertiesAndMethodByPermutation: function () {
                switch (this.permutation) {
                    case CP_CONST.SNIPPET_PERMUTATION.PANEL:
                        this.templateHelpers = this.showDescription();
                        break;

                    case CP_CONST.SNIPPET_PERMUTATION.RELATED:
                        this.$el.addClass('permutation-vertical');
                        break;

                    case CP_CONST.SNIPPET_PERMUTATION.CHAT:
                        this.$el.addClass('permutation-highlight');
                        this.templateHelpers = this.showDescription();
                        break;
                }
            },

            showDescription: function () {
                return {
                    desc: true
                };
            }
        });
    });

    return KPSnippetView;
});
